import { useRouter } from 'next/router'
import { GuestList as View } from 'ui-components'
import { useIsWorkspaceOwner } from '~workspace/hooks/useIsWorkspaceOwner'
import { useDeleteInvitedUser } from '~workspace/queries/useDeleteInvitedUser'
import {
  useGetCurrentWorkspaceGuests,
  useGetCurrentWorkspaceInvitedUsers
} from '~workspace/queries/useGetWorkspaceById'
import { useUpgradeToMember } from '~workspace/queries/useUpgradeToMember'
import { InvitedUser, Member } from '~workspace/types/__generated/gql/graphql'

export const GuestList = () => {
  const { query } = useRouter()

  const isWorkspaceOwner = useIsWorkspaceOwner()
  const guests = useGetCurrentWorkspaceGuests()
  const invitedUsers = useGetCurrentWorkspaceInvitedUsers()
  const deleteInvitedUser = useDeleteInvitedUser()
  const upgradeToMember = useUpgradeToMember()

  const guestInvitedUsers = invitedUsers?.filter(
    (invitedUser) => invitedUser.role === 'guest'
  )

  const handleRemoveGuestConfirm = async (userId) => {
    await deleteInvitedUser.mutateAsync({
      userId,
      workspaceId: query.workspaceId!.toString()
    })
  }

  const handleUpgradeToMemberConfirm = async (userId) => {
    await upgradeToMember.mutateAsync({
      userId,
      workspaceId: query.workspaceId!.toString()
    })
  }

  return (
    <View
      canRemoveGuest={isWorkspaceOwner}
      canUpgradeToMember={isWorkspaceOwner}
      isRemovingGuest={deleteInvitedUser.isPending}
      guests={guests as Member[]}
      invitedUsers={guestInvitedUsers as InvitedUser[]}
      onRemoveGuestConfirm={handleRemoveGuestConfirm}
      onUpgradeToMemberConfirm={handleUpgradeToMemberConfirm}
    />
  )
}
